import { useContext } from 'react'
import { LegalAcceptanceContext } from '@/providers/legal-acceptance-provider'

export function useLegalAcceptance() {
  const context = useContext(LegalAcceptanceContext)

  if (!context) {
    throw new Error('useLegalAcceptance must be used within a LegalAcceptanceProvider')
  }

  return context
}
